import AxiosService from "plugins/TS-lib-utils-public/services/AxiosService"; 

class KitsService extends AxiosService {
    constructor() {
        super('management');
    }

    getKit = async (kitId, { cancelToken = null } = {}) => {
        return await this.get(
            `/kits/${kitId}`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }
  
    getKitsList = async (page, limit, state = null, search = null, { cancelToken = null } = {}) => {
        let query = `/kits/list/?page=${page}&limit=${limit}`;
        if (search) {
            query += `&search=${search}`;
        }

        if (state) {
            query += `&state=${state}`;
        }

        const response = await this.get(
            query,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
        return response;
    };

    createKit = async (data, { cancelToken = null } = {}) => {
        return await this.post(
            `/kits`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    editKit = async (data, { cancelToken = null } = {}) => {
        return await this.put(
            `/kits/${data.kitId}`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    deleteKit = async (kitId, { cancelToken = null } = {}) => {
        return await this.delete(
            `/kits/${kitId}`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    getTypes = async ({ cancelToken = null } = {}) => {
        return await this.get(
            `/kits/types`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    getKitStateMachine = async ({ cancelToken = null } = {}) => {
        return await this.get(
            `/kits/state-machine`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    // #2121 - Grupos (5 fases) + mapeo estado -> grupo. Lo consume el stepper.
    getKitStateGroups = async ({ cancelToken = null } = {}) => {
        return await this.get(
            `/kits/state-groups`,
            {
                headers: { Authorization: `Bearer ${this.getToken()}` },
                cancelToken,
            }
        );
    }

    getKitStateList = async ({ cancelToken = null } = {}) => {
        return await this.get(
            `/kits/states`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    // #2121-spec-kits — practiceId opcional. Filtra por practica.
    getCountByTypes = async (practiceId = null, { cancelToken = null } = {}) => {
        const q = practiceId ? `/kits/count?practiceId=${practiceId}` : `/kits/count`;
        return await this.get(
            q,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    // #2121-spec-kits — practiceId opcional. Filtra por practica.
    getKitsCountByState = async (practiceId = null, { cancelToken = null } = {}) => {
        const q = practiceId ? `/kits/count-state?practiceId=${practiceId}` : `/kits/count-state`;
        return await this.get(
            q,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    getPatientKits = async (page, limit, state, search = null, { cancelToken = null } = {}) => {
        let query;
        if (search) {
            query = `/kits/patients/list/?page=${page}&limit=${limit}&state=${state}&search=${search}`;
        } else {
            query = `/kits/patients/list/?page=${page}&limit=${limit}&state=${state}`;
        }
        const response = await this.get(
            query,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
        return response;
    };

    updatePatientKistStatus = async (kitId, status, { cancelToken = null } = {}) => {
        return await this.put(
            `/kits/patients/${kitId}/status`,
            {status: status},
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    saveKitObservations = async (kitId, observations, { cancelToken = null } = {}) => {
        return await this.post(
            `/kits/${kitId}/observations`,
            {observations: observations},
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    clearKit = async (kitId, { cancelToken = null } = {}) => {
        return await this.get(
            `/kits/${kitId}/clear`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    saveTrackingId = async (kitId, trackingId, { cancelToken = null } = {}) => {
        return await this.post(
            `/kits/${kitId}/tracking-info`,
            {tracking: trackingId},
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

}
export default new KitsService();
